import React from 'react';

import { SiteConfigManager, useApplicationState } from '@atlas/core';
import { Label, SeparateBalance } from '@atlas/ui';

import MoneyValueCustomCurrency from 'src/components/MoneyValueCustomCurrency/MoneyValueCustomCurrency';

const HeaderInfoAuthorizedBalance = () => {
  const {
    wallet: {
      detailedBalance: { BONUS = 0, CASH = 0, FROZEN = 0 },
    },
  } = useApplicationState();
  const isSeparateBalance = SiteConfigManager.getConfig(
    'config.config.general.desktopSeparateRealAndBonusBalances',
  );

  const realBalance = CASH + FROZEN;

  if ([CASH, FROZEN].some(value => typeof value !== 'number')) {
    return (
      <div className="verify-status">
        <div className="label-with-icon status-label">
          <Label message="balance_is_unavailable" />
        </div>
      </div>
    );
  }

  if (isSeparateBalance) {
    return (
      <SeparateBalance
        balance={<MoneyValueCustomCurrency className="balance-value" value={realBalance} />}
        bonus={<MoneyValueCustomCurrency className="balance-value" value={BONUS} />}
        className="balance"
      >
        <MoneyValueCustomCurrency className="balance-value" value={realBalance} />
      </SeparateBalance>
    );
  }

  return (
    <div className="balance">
      <MoneyValueCustomCurrency className="balance__main" value={realBalance} />

      <div className="balance__bonus">
        <Label className="balance__text" message="bonus_balance_header" />
        <MoneyValueCustomCurrency className="balance__amount" value={BONUS} />
      </div>
    </div>
  );
};

export default HeaderInfoAuthorizedBalance;
